import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"
const handleCopyNumeroLote = (value) => {
    if (value) {
        navigator.clipboard.writeText(String(value))
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Copiado al portapapeles')
    }
}

const DevolucionesGridModal = ({ lote, onCancel }) => {

    const { setIsLoading } = useManagedContext()

    const [devoluciones, setDevoluciones] = useState([])
    const [idReciboPublicacion, setIdReciboPublicacion] = useState(null)


    useEffect(() => {
        if (lote.id > 0) {
            SearchDevoluciones(lote.id)
        }
    }, [])

    const SearchDevoluciones = (idDevolucionLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idDevolucionLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setDevoluciones(data)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.idReciboPublicacion) {
                setIdReciboPublicacion(item.idReciboPublicacion)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title={`Devoluciones (${getDateToString(lote.fechaLote)})`}
            body={(
                <>
                    <div className="row mb-3">
                        <div className="mb-3 col-12 col-lg-6">
                            <label className="form-label">N° lote</label>
                            <div className="wrapper">
                                <input
                                    type="text"
                                    className="form-control text-truncate"
                                    style={{ paddingRight: lote.numeroLote ? '28px' : undefined }}
                                    value={lote.numeroLote || '-'}
                                    disabled={true}
                                    title={lote.numeroLote ? String(lote.numeroLote) : ''}
                                />
                                {lote.numeroLote && (
                                    <span
                                        className="material-symbols-outlined icon-cruz"
                                        style={{ right: '2px', fontSize: '18px' }}
                                        onClick={() => handleCopyNumeroLote(lote.numeroLote)}
                                        title="Copiar"
                                    >content_copy</span>
                                )}
                            </div>
                        </div>
                        <div className="mb-3 col-12 col-lg-6">
                            <label className="form-label">Importe total</label>
                            <input type="text" className="form-control" value={getFormatNumber(lote.importeTotal, 2)} disabled={true} />
                        </div>
                    </div>
                    <TableCustom
                        className={'TableCustomBase m-top-10'}
                        data={devoluciones}
                        avmr={avmr}
                        columns={[
                            { Header: 'N° control', accessor: 'numeroControl', width: '10%' },
                            { Header: 'N° cuenta', accessor: 'numeroCuenta', width: '20%' },
                            {
                                Header: 'Identificador VEP',
                                accessor: 'numeroRecibo',
                                width: '25%',
                                Cell: ({ row }) =>
                                    row.original.numeroRecibo > 0
                                        ? getNumeroRecibo_ObjectToIdentificador(row.original)
                                        : row.original.codigoBarras
                            },
                            { Header: 'Fecha de conciliación', accessor: 'fechaConciliacion', Cell: data => getDateToString(data.value), width: '15%' },
                            { Header: 'Fecha de cobro', accessor: 'fechaCobro', Cell: data => getDateToString(data.value), width: '15%' },
                            { Header: 'Importe', accessor: 'importeCobro', Cell: data => getFormatNumber(data.value, 2), width: '15%', alignCell: 'right' },
                        ]}
                        showDownloadCSV={true}
                    />

                    {idReciboPublicacion && (
                        <ReciboPublicacionModal
                            id={idReciboPublicacion}
                            onCancel={() => setIdReciboPublicacion(null)}
                        />
                    )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default DevolucionesGridModal
